import React, { useState } from 'react'
import { Button, Card, Col, Row, Modal, Tabs, Skeleton, message } from 'antd'
import ds from '../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useStore, useDispatch, useSelector } from 'react-redux'
import IntlMessages from '../util/IntlMessages'
import {
  loadIsSelectReg,
  loadUserSelectOutReg
} from '../appRedux/actions/CommonData'
import {
  loadSelectedStoreOutlets,
  loadSelectedOutletRegisters,
  loadOutletRegisters,
  loadRegOutletsLoading,
  loadRegOfSelectedOut
} from '../appRedux/actions/Sell'
import { getDecryptID } from '../appRedux/actions'

const OutletRegSelect = props => {
  const selOut = props.out ? props.out : false
  const selReg = props.reg ? props.reg : false
  const dispatch = useDispatch()
  const history = useHistory()
  const { TabPane } = Tabs

  const getReduxShowRegSel = useSelector(
    ({ commonConfigs }) => commonConfigs.getIsSelectReg
  )
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxOutletReg = useSelector(({ Sell }) => Sell.openCloseOutletReg)
  const getReduxRegOutLoading = useSelector(
    ({ Sell }) => Sell.openCloseRegOutletsLoading
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const asd = useSelector(({ auth }) => auth.authdVariable)

  const [visible, setVisible] = React.useState(false)
  const [isLoading, setisLoading] = React.useState(false)
  const [getKey, setKey] = React.useState('')
  const [getSelectedOutlet, setSelectedOutlet] = React.useState({})
  const [getSelectedReg, setSelectedReg] = React.useState({})
  const [tempSelOut, setTempSelOut] = React.useState('')

  const storageOutID =
    localStorage.getItem('selectedOut') &&
    JSON.parse(localStorage.getItem('selectedOut')) &&
    JSON.parse(localStorage.getItem('selectedOut')).id
      ? getDecryptID(JSON.parse(localStorage.getItem('selectedOut')).id)
      : false

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      setSelectedOutlet(selOut)
      setSelectedReg(selReg)
      if (getReduxOutletReg && getReduxOutletReg.length == 0) {
        if (getReduxStoreOutlets && getReduxStoreOutlets.length > 0) {
          if (!selOut && !storageOutID) {
            setSelectedOutlet(getReduxStoreOutlets[0])
            localStorage.setItem(
              'selectedOut',
              JSON.stringify(getReduxStoreOutlets[0])
            )
            dispatch(loadSelectedStoreOutlets(getReduxStoreOutlets[0]))
          }
          let body = {
            OutletID:
              selOut && selOut.id
                ? selOut.id
                : getReduxStoreOutlets[0].id
                ? getReduxStoreOutlets[0].id
                : false
          }
          if (body.OutletID) {
            dispatch(loadRegOutletsLoading(true))
            dispatch(loadOutletRegisters(body, isOnline))
          }
        }
      }
    }

    return () => (mounted = false)
  }, [selOut, selReg, getReduxShowRegSel, getReduxStoreOutlets])

  function onOutletClick (outlet) {
    localStorage.setItem('selectedReg', '')
    dispatch(loadSelectedOutletRegisters({}))
    dispatch(loadRegOfSelectedOut([]))
    setSelectedOutlet(outlet)
    setSelectedReg({})
    dispatch(loadSelectedStoreOutlets(outlet))
    let localOutlet = JSON.stringify(outlet)
    localStorage.setItem('selectedOut', localOutlet)
    if (outlet.id) {
      // let body = {
      //   OutletID: outlet.id
      // }
      let postBody = {
        OutletID: outlet.id,
        RegisterID: ''
      }
      dispatch(loadRegOutletsLoading(true))
      // dispatch(loadOutletRegisters(body, isOnline))
      // dispatch(loadUserSelectOutReg(postBody))
    }
  }

  function onRegClick (reg) {
    onOutletClick(getSelectedOutlet)
    let postBody = {
      OutletID: getSelectedOutlet ? getSelectedOutlet.id : '',
      // OutletID: getReduxSelectedStoreOutlets
      //   ? getReduxSelectedStoreOutlets.id
      //   : '',
      RegisterID: reg.id
    }
    setSelectedReg(reg)
    let localReg = JSON.stringify(reg)
    localStorage.setItem('selectedReg', localReg)
    dispatch(loadSelectedOutletRegisters(reg))
    dispatch(loadUserSelectOutReg(postBody))
    setTimeout(() => {
      dispatch(loadIsSelectReg(false))
    }, 1000)
  }

  function onTabChange (e) {
    const tabs = getReduxStoreOutlets
    const data =
      tabs && tabs.length > 0 ? tabs.filter(a => getDecryptID(a.id) == e) : []
    if (data && data.length > 0) {
      dispatch(loadRegOfSelectedOut([]))
      setSelectedOutlet(data[0])
      dispatch(
        loadOutletRegisters(
          {
            OutletID: data[0].id
          },
          isOnline
        )
      )
      // onOutletClick(data[0])
    } else {
      message.warn('Something wrong, Kindly refresh and select again')
    }
  }

  return (
    <Modal
      className='Outlet-Register-modal'
      title={<span>Select Outlet & Register</span>}
      centered
      visible={getReduxShowRegSel}
      footer={
        <>
          <Button
            onClick={() => dispatch(loadIsSelectReg(false))}
            size='large'
            className='dk-btn-cancel'
          >
            Close
          </Button>
        </>
      }
      onCancel={() => {
        if (getReduxSelectedOutletReg && getReduxSelectedOutletReg.id) {
          dispatch(
            loadOutletRegisters(
              {
                OutletID: getReduxSelectedOutletReg.id
              },
              isOnline
            )
          )
        }
        dispatch(loadIsSelectReg(false))
      }}
      width={900}
    >
      <div>
        <Tabs
          activeKey={
            getSelectedOutlet && getSelectedOutlet.id
              ? getSelectedOutlet.id.substring(
                  0,
                  getSelectedOutlet.id.indexOf('&')
                )
              : storageOutID
              ? storageOutID
              : ''
          }
          size='large'
          animated
          onChange={onTabChange}
        >
          {getReduxStoreOutlets &&
          getReduxStoreOutlets.length &&
          getReduxStoreOutlets.length > 0 ? (
            getReduxStoreOutlets.map((e, key) => {
              return (
                <TabPane
                  tab={
                    <div
                    // onClick={() => onOutletClick(e)}
                    >
                      {e.outlet}
                    </div>
                  }
                  key={
                    e.id && e.id.includes('&')
                      ? e.id.substring(0, e.id.indexOf('&'))
                      : ''
                  }
                  style={{ fontWeight: 'bold' }}
                  forceRender
                >
                  {getReduxRegOutLoading ? (
                    <Skeleton count={5} height={30} />
                  ) : (
                    <div className='outlet-cards'>
                      <Row gutter={10}>
                        {getReduxOutletReg &&
                        getReduxOutletReg.length &&
                        getReduxOutletReg.length > 0 ? (
                          getReduxOutletReg.map((d, key) => {
                            let spanWidth = 24
                            let id = d.id
                              ? d.id.substring(0, d.id.indexOf('&'))
                              : ''
                            let selectedID =
                              getSelectedReg && getSelectedReg.id
                                ? getSelectedReg.id.substring(
                                    0,
                                    getSelectedReg.id.indexOf('&')
                                  )
                                : 'XXX'
                            if (getReduxOutletReg.length < 4) {
                              spanWidth = parseInt(
                                spanWidth / getReduxOutletReg.length
                              )
                            } else {
                              spanWidth = parseInt(spanWidth / 3)
                            }
                            return (
                              <Col key={key} span={spanWidth}>
                                <Card
                                  hoverable
                                  className={`${
                                    id == selectedID
                                      ? 'ant-regcard-bordered-active Selected-Register'
                                      : 'ant-regcard-bordered-deactive'
                                  }`}
                                  onClick={() => onRegClick(d)}
                                >
                                  <div className='Register-cart'>
                                    <h3>{d.register}</h3>
                                    <p className='mt-0 mb-0'>
                                      {id == selectedID ? (
                                        <IntlMessages id='reg.opendialog.subtitle1' />
                                      ) : (
                                        <IntlMessages id='reg.opendialog.subtitle2' />
                                      )}
                                    </p>
                                  </div>
                                </Card>
                              </Col>
                            )
                          })
                        ) : (
                          <div>
                            <Col span={24}>
                              <h2 className='gx-text-danger'>
                                {' '}
                                Kindly Add Register from Setup Menu{' '}
                              </h2>
                            </Col>
                          </div>
                        )}
                      </Row>
                    </div>
                  )}
                </TabPane>
              )
            })
          ) : (
            <div style={{ marginTop: '2%' }}>
              <span>
                <h2>{'Check connection & Reload'}</h2>
              </span>
            </div>
          )}
        </Tabs>
      </div>
    </Modal>
  )
}

export default OutletRegSelect
